<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentTransfer.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentTransfer.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="showForm()">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.student.full_name_en }}</td>
          <td class="text-center">{{ record.transfered_date }}</td>
          <td>{{ record.from_branch.branch_name_en }}</td>
          <td>
            {{
              record.to_branch
                ? record.to_branch.branch_name_en
                : record.from_branch.branch_name_en
            }}
          </td>
          <td>
            {{
              record.from_class.class_name +
                '_' +
                (record.from_class.academic_study_time
                  ? record.from_class.academic_study_time.study_time
                  : '') +
                '_' +
                (record.from_class.teacher
                  ? record.from_class.teacher.full_name_en
                  : '')
            }}
          </td>
          <td>
            {{
              record.to_class.class_name +
                '_' +
                (record.to_class.academic_study_time
                  ? record.to_class.academic_study_time.study_time
                  : '') +
                '_' +
                (record.to_class.teacher
                  ? record.to_class.teacher.full_name_en
                  : '')
            }}
          </td>
          <td>{{ record.comment }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="showEditForm(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
import EditFormComponent from './edit'
export default {
  name: 'studentTransfer',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('studentTransfer', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('studentTransfer.studentName')
        },
        {
          name: this.$t('studentTransfer.date'),
          style: 'text-align:center'
        },
        {
          name: this.$t('studentTransfer.fromBranch')
        },
        {
          name: this.$t('studentTransfer.toBranch')
        },
        {
          name: this.$t('studentTransfer.fromClass')
        },
        {
          name: this.$t('studentTransfer.toClass')
        },
        {
          name: this.$t('studentTransfer.comment')
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get() {
        return this.$store.state.studentTransfer.search
      },
      set(newValue) {
        this.$store.commit('studentTransfer/SET_SEARCH', newValue)
        this.$store.commit('studentTransfer/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showEditForm(editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('studentTransfer/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('studentTransfer/RESET_STATE')
    next()
  }
}
</script>
